import { call, put, takeLatest, select } from "redux-saga/effects";
import * as actionTypes from "../reducers/actionTypes";
import { actions } from "../reducers/cpDeliveryRoutesReducer";
import {
  getDbTouchpoints,
  assignTouchpointBulk,
  updateDBRoute,
} from "@services/api";

function* fetchDeliveryRoutes(action) {
  try {
    yield put(actions.setLoading(true));
    
    const { data } = yield call(getDbTouchpoints, {
      type: action.isCurrentDeliveryTab ? "TODAY" : "UPCOMING",
      route_id: action.routeId,
    });
    
    yield put(actions.fetchDataSuccess(data));
  } catch (error) {
    console.error("Error fetching delivery routes:", error);
    yield put(actions.fetchDataFail(error));
  }
}

function* assignTouchpointBulkSaga(action) {
  try {
    yield put(actions.setLoading(true));
    
    const payload = {
      tps: action.data,
      type: action.isCurrentDeliveryTab ? "TODAY" : "UPCOMING",
    };
    
    yield call(assignTouchpointBulk, payload);
    yield put(actions.assignTouchpointBulkSuccess());
    
    // Get the current selected route ID from state
    const { selectedRouteId, isCurrentDeliveryTab } = yield select(state => state.cpDeliveryRoutesReducer);
    
    // Refetch data after successful assignment
    yield put(actions.fetchData(selectedRouteId, isCurrentDeliveryTab));
  } catch (error) {
    console.error("Error assigning touchpoints:", error);
    yield put(actions.assignTouchpointBulkFail(error));
  }
}

function* updateDbRouteSaga(action) {
  try {
    yield put(actions.setLoading(true));
    
    yield call(updateDBRoute, action.payload);
    yield put(actions.updateDbRouteSuccess());
    
    // Get the current selected route ID from state
    const { selectedRouteId, isCurrentDeliveryTab } = yield select(state => state.cpDeliveryRoutesReducer);
    
    // Refetch data after successful update
    yield put(actions.fetchData(selectedRouteId, isCurrentDeliveryTab));
  } catch (error) {
    console.error("Error updating DB route:", error);
    yield put(actions.updateDbRouteFail(error));
  }
}

export default function* cpDeliveryRoutesSaga() {
  yield takeLatest(actionTypes.FETCH_DELIVERY_ROUTES_REQ, fetchDeliveryRoutes);
  yield takeLatest(
    actionTypes.ASSIGN_TOUCHPOINT_BULK_REQ,
    assignTouchpointBulkSaga,
  );
  yield takeLatest(actionTypes.UPDATE_DB_ROUTE_REQ, updateDbRouteSaga);
}
